import CodeLine from "../CodeLine/CodeLine";
import "./About.scss";

export default function Description() {
  const description = [
    "/**",
    " * About me",
    " * I am a full-stack developer",
    " * with a university degree in computer technology,",
    " * and I possess hands-on experience in building websites.",
    " * My strong problem-solving skills enable me ",
    " * to overcome challenges effectively.",
    " *",
    " * I am highly motivated to continuously enhance my skills",
    " * and professional expertise.",
    " * By utilizing the latest technologies,",
    " * I design and develop web applications with",
    " * a focus on delivering high-quality code.",
    " *",
    " */",
  ];
  return (
    <div className="description-layout">
      <div className="description-layout__desktop">
        {description.map((line, idx) => (
          <CodeLine
            key={idx}
            lineNumber={idx + 1}
            words={[{ text: line, class: "comment" }]}
          />
        ))}
      </div>
      <div className="description-layout__mobile">
        I am a full-stack developer with a university degree in computer
        technology, and I possess hands-on experience in building websites. My
        strong problem-solving skills enable me to overcome challenges
        effectively. I am highly motivated to continuously enhance my skills and
        professional expertise. By utilizing the latest technologies, I design
        and develop web applications with a focus on delivering high-quality
        code.
      </div>
    </div>
  );
}
